import React, { useContext, useRef, useState } from 'react';
import message from 'antd/lib/message';
import { Select } from 'antd';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useMutation, useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import { fetchRtNo, getDayBook } from '../../NecttosComp/APICaller/ApiServices';
import moment from 'moment';
import LoadingAnimation from '../../components/LoadingAnimation';
import Scrollbars from 'react-custom-scrollbars';
import ReactToPrint from 'react-to-print';
import SearchableImput from '../../NecttosComp/Input/SearchableImput';
import Input from '../../NecttosComp/Input/Input';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import { Table, Thead, Tr, Td, Th, Tbody, Tfoot, TfootTr, TfootTd } from '../../NecttosComp/Table/Table';
import { FaSearch } from 'react-icons/fa';
import { sumWithKey } from '../../utils';
import Button from '../../NecttosComp/Button/Button';
import Input2 from '../../NecttosComp/Input/Input2';
import Instruction from '../../Documentation/Instruction';

export const exportPdfCollectionReport = async (data) => {
	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.post(`/college/reportGeneration/generateCollectionReport`, data, {
			responseType: 'blob',
		});
		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			return resp.data;
		}
	} catch (error) {
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};

function groupBy(objectArray, property) {
	return objectArray?.reduce((acc, obj) => {
		const key = obj[property];
		if (!acc[key]) {
			acc[key] = [];
		}
		acc[key].push(obj);
		return acc;
	}, {});
}

export const DayBook2 = ({ onClose }) => {
	const { collegeId, collegeList } = useContext(FirebaseContext);
	const componentRef = useRef();
	const selectedCollege = collegeList?.find((x) => x.collegeId === collegeId);
	const [date, setDate] = useState({
		date: '',
	});
	const [state, setState] = useState({
		date: '',
		from: '',
		to: '',
		amount: '',
		naration: '',
	});
	const [rtModal, setRtModal] = useState(false);
	const [rtNo, setRtNo] = useState({});
	const [rtDate, setRtDate] = useState({});
	const [isLoading, setIsLoading] = useState(false);
	const { Option } = Select;
	const exportPdfMutationDateCollectionReport = useMutation(exportPdfCollectionReport);
	const { data = [], isFetching, refetch } = useQuery(['getDayBoook', date.date], getDayBook(collegeId, date.date));
	const { data: rtData } = useQuery(['fetchRtNo', rtNo?.start, rtNo?.end, rtDate?.startDate, rtDate?.endDate], () => fetchRtNo({ collegeId, start: rtNo?.start, end: rtNo?.end, startDate: rtDate?.startDate, endDate: rtDate?.endDate }), {
		enabled: !!rtNo?.start && !!rtNo?.end,
	});

	const grouped = Object.entries(groupBy(rtData?.listData || [], 'amount'))?.map(([key, values]) => ({
		title: key,
		total: sumWithKey(values, 'amount'),
		count: values.length,
	}));

	const handleReset = () => {
		setRtNo('');
		setRtDate('');
	};

	let fromAccounts = data.mainAccounts;
	let toAccounts = data.mainAccounts;
	let denomsSplitup = data.denomsSplitup;
	let billNumber = data.billNumber;

	const onDateCollectionReport = async () => {
		try {
			const link = document.createElement('a');
			link.target = '_blank';
			let postData = {
				startDate: state?.startDate,
				endDate: state?.endDate,
				startTime: state?.startTime,
				endTime: state?.endTime,
				collegeId,
			};

			link.download = state?.endDate;
			const pdfData = await exportPdfMutationDateCollectionReport.mutateAsync(postData);
			link.href = URL.createObjectURL(new Blob([pdfData], { type: 'application/pdf' }));
			link.click();
		} catch (e) {}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		try {
			const postData = {
				collegeId,
				type: 'payment',
				date: state.date,
				from: state.from,
				receiptNo: state.receiptNo,
				to: state.to,
				amount: state.amount,
				paidTo: state.paidTo,
				naration: state.naration,
			};
			setIsLoading(true);
			const instance = await getAxiosTokenInstance();
			let resp = await instance.post('/college/fees/accounts', postData);
			message.success(resp?.message || 'Journal Posted');
			setState({
				from: '',
				date: '',
				naration: '',
				to: '',
				amount: '',
				receiptNo: '',
			});
			refetch();
		} catch (error) {
			message.error(error?.response?.data?.message || error?.message || 'API Error');
		} finally {
			setIsLoading(false);
		}
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setState((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	return (
		<Main width='90%' title='Day Book' className=' h-auto z-50'>
			<Header className='w-full px-6 py-4 flex items-center justify-between flex-wrap gap-4'>
				<div className='flex-1 text-start'>
					<h2 className='text-xl font-bold text-slate-800 dark:text-slate-100'>Day Book as on {moment(data?.date).format('ddd DD MMM YYYY')}</h2>
				</div>{' '}
				<div className='w-auto'>
					<Input2 type='date' fieldName='Date' returnKey='date' state={date} setState={setDate} className='font-semibold w-52 outline-none bg-transparent' />
				</div>
				<div className='flex items-center gap-3 justify-end'>
					<Button type='fetch' onClick={refetch}>
						Reload
					</Button>
					<Instruction keyId={'dayBook'}></Instruction>
					<Button className='w-auto' type='print' tableRef={componentRef.current}>
						Print
					</Button>
					{!isLoading && (
						<Button type='close' onClick={onClose}>
							Close
						</Button>
					)}
				</div>
			</Header>

			<Body width='100%'>
				<div className='flex w-[100%] h-[99%] bg-slate-100 dark:bg-neutral-800 rounded-3xl'>
					<div className='flex flex-col items-center w-[23%] p-5 border-r border-slate-700 dark:border-slate-100'>
						{isLoading ? (
							<LoadingAnimation dark />
						) : (
							<>
								<div className='w-full max-w-md mx-auto py-2'>
									<h2 className='text-2xl text-center font-extrabold text-slate-800 dark:text-slate-100 mb-2'>Journal Entry</h2>

									<form onSubmit={handleSubmit} className='flex flex-col gap-2'>
										<Input2 type='date' fieldName='Entry Date' returnKey='date' state={state} setState={setState} className='w-[230px] text-base font-medium py-2 outline-none' required />

										<Input2
											type='drop'
											fieldName='From Account'
											returnKey='from'
											state={state}
											setState={setState}
											options={fromAccounts?.map((item, i) => ({
												label: item.name,
												value: fromAccounts?.find((x, j) => x.name + j === item.name + i)?._id,
											}))}
											didntShowKey
											optionDisplay='label'
											optionKey='value'
											className='h-12 w-[230px]  rounded-lg'
										/>

										<Input2
											type='drop'
											fieldName='To Account'
											returnKey='to'
											state={state}
											setState={setState}
											options={toAccounts?.map((item, i) => ({
												label: item.name,
												value: toAccounts?.find((x, j) => x.name + j === item.name + i)?._id,
											}))}
											didntShowKey
											optionDisplay='label'
											optionKey='value'
											className=' w-[230px] h-12'
										/>

										<Input2 type='number' fieldName='Amount' returnKey='amount' state={state} setState={setState} className=' w-[230px] h-12 font-bold text-lg py-2 outline-none' required />

										<div className='w-[230px] flex flex-col gap-2'>
											<SearchableImput keyData='paidTo' titleData='Paid To' collection='accounts' stateData={state} setStateData={setState} className='w-full' />

											<SearchableImput keyData='naration' titleData='Narration' collection='accounts' stateData={state} setStateData={setState} className='w-full' />
										</div>

										<Input2 type='number' fieldName={`Receipt No ${billNumber}`} returnKey='receiptNo' state={state} setState={setState} className=' w-[230px] h-12 text-base py-2 outline-none' />

										<div className='flex gap-3 mt-4'>
											<Button
												type='close'
												className='flex-1 rounded-lg'
												onClick={() => {
													setState({
														from: '',
														date: '',
														naration: '',
														to: '',
														amount: '',
														receiptNo: '',
													});
												}}>
												Cancel
											</Button>
											<Button type='save' className='flex-1 h-11'>
												Post Entry
											</Button>
										</div>
									</form>
								</div>

								<div className='w-full mt-4 rounded-xl shadow-md p-4 bg-red-200 dark:bg-red-900 overflow-y-auto'>
									<div className='flex justify-end mb-3'>
										<Button type='search' className='w-20 px-3 py-1 rounded-lg bg-blue-400 dark:bg-blue-600 text-black dark:text-white flex items-center justify-center gap-2' onClick={() => setRtModal(true)}>
											<FaSearch />
											<span className='text-sm'>Rt</span>
										</Button>
									</div>

									<p className='text-xl text-center font-bold text-slate-700 dark:text-slate-100'>Date: {moment(data.date, 'YYYY-MM-DD').format('DD-MM-YYYY')}</p>
									<p className='text-xl text-center font-bold text-slate-700 dark:text-slate-100'>Rt No: {data.billsData}</p>
									<p className='text-xl text-center font-bold text-slate-700 dark:text-slate-100 mt-4'>Denominations</p>

									<div className='flex flex-col gap-3 mt-4'>
										{denomsSplitup?.map((item, idx) => (
											<div key={idx} className='flex justify-center items-center gap-3'>
												<span className='text-base font-semibold text-slate-700 dark:text-slate-100 w-16 text-right'>{item?.item}</span>
												<span className='text-base font-semibold text-slate-700 dark:text-slate-100'>×</span>
												<span className='text-base font-semibold text-slate-700 dark:text-slate-100 w-10 text-right'>{item?.count}</span>
												<span className='text-base font-semibold text-slate-700 dark:text-slate-100'>=</span>
												<span className='text-base font-semibold text-slate-700 dark:text-slate-100 w-16 text-right'>{item?.total}</span>
											</div>
										))}
									</div>

									<p className='mt-6 text-xl text-center font-bold text-green-700 dark:text-green-700'>Grand Total: {data.total}</p>
								</div>
							</>
						)}
					</div>
					<div className='w-[77%] flex flex-col p-5'>
						<Scrollbars style={{ height: '90%' }}>
							<div ref={componentRef} className='printable'>
								<img src={selectedCollege?.logo} alt='College Logo' className='hidden print:block absolute w-[80%] opacity-10 top-[350px] left-[100px] z-10 pointer-events-none' />

								<div className='w-full flex flex-col rounded-3xl p-1'>
									<div className='w-full flex flex-row rounded-3xl'>
										<img width='12%' height='12%' src={selectedCollege?.logo} alt='College Logo' />
										<div className='w-[80%] items-center m-0 text-center'>
											<span className='text-3xl m-0 font-black text-slate-800 dark:text-slate-100'>{selectedCollege?.collegeShortName}</span>
											<p className='text-2xl m-0 font-black text-slate-800 dark:text-slate-100'>{selectedCollege?.accreditedGrade}</p>
											<p className='text-sm m-0 font-black text-slate-800 dark:text-slate-100'>
												{selectedCollege?.address}, Phone: {selectedCollege?.phoneNumber}
											</p>
										</div>
									</div>
									<h5 className='mt-3 mb-3 text-3xl w-full self-start text-slate-800 dark:text-slate-100'>Issue Register</h5>
									<Table width='100%' innerWidth={['10%', '40%', '10%', '10%', '10%', '10%', '10%']}>
										<Thead>
											<Tr>
												<Th position={0}>Sn</Th>
												<Th position={1}>Account</Th>
												<Th position={2}>Op. Balance</Th>
												<Th position={3}>Receipt</Th>
												<Th position={4}>Payments</Th>
												<Th position={5}>Refund</Th>
												<Th position={6}>Cl. Balance</Th>
											</Tr>
										</Thead>
										<Tbody height='65vh'>
											{data?.dayBook?.map((item, i) => (
												<Tr key={i} index={i}>
													<Td position={0} index={i}>
														{i + 1}
													</Td>
													<Td position={1} index={i}>
														{item.name}
													</Td>
													<Td position={2} index={i}>
														{item.totalActualOpeingBalance?.toFixed(2)}
													</Td>
													<Td position={3} index={i}>
														{item.totalCurrentAmount?.toFixed(2)}
													</Td>
													<Td position={4} index={i}>
														{item.currentPayment?.toFixed(2)}
													</Td>
													<Td position={5} index={i}>
														{item.currentRefund?.toFixed(2)}
													</Td>
													<Td position={6} index={i}>
														{item.totalClossingBalance?.toFixed(2)}
													</Td>
												</Tr>
											))}
										</Tbody>
									</Table>
									<h5 className='mt-3 text-right text-slate-800 dark:text-slate-100 text-lg'>Seal & Signature {moment(new Date()).format('DD MMM YYYY hh:mm A')}</h5>
								</div>
							</div>
						</Scrollbars>
					</div>
				</div>
			</Body>
			{rtModal && (
				<Main width='80vw' height='100vh'>
					<Header className='flex items-center flex-wrap gap-3 mt-6 ml-6'>
						<Input width='18%' type='number' fieldName='Start Receipt No' returnKey='start' state={rtNo} setState={setRtNo} />
						<Input width='18%' type='number' fieldName='End Receipt No' returnKey='end' state={rtNo} setState={setRtNo} />
						<Input width='15%' type='date' fieldName='Start Date' returnKey='startDate' state={rtDate} setState={setRtDate} />
						<Input width='15%' type='date' fieldName='End Date' returnKey='endDate' state={rtDate} setState={setRtDate} />
						<Button type='fetch' onClick={fetchRtNo}>
							Refetch
						</Button>
						<Button type='update' onClick={handleReset}>
							Reset
						</Button>
						<Button type='close' onClick={() => setRtModal(false)}>
							Close
						</Button>
					</Header>

					<Table width='100%' innerWidth={['5%', '20%', '5%', '20%', '5%', '45%']}>
						<Thead>
							<Tr>
								<Th position={0} fontSize='20px'>
									S.N
								</Th>
								<Th position={1} fontSize='20px'>
									Fee
								</Th>
								<Th position={2} fontSize='20px'>
									-
								</Th>
								<Th position={3} fontSize='20px'>
									Count
								</Th>
								<Th position={4} fontSize='20px'>
									-
								</Th>
								<Th position={5} fontSize='20px'>
									Total
								</Th>
							</Tr>
						</Thead>

						<Tbody height='65vh'>
							{rtData?.listData?.length > 0 ? (
								grouped?.map((rt, index) => (
									<Tr key={index} index={index}>
										<Td position={0} index={index} fontSize='20px'>
											{index + 1}
										</Td>
										<Td position={1} index={index} fontSize='20px'>
											{rt?.title}
										</Td>
										<Td position={2} index={index} fontSize='20px'>
											X
										</Td>
										<Td position={3} index={index} fontSize='20px'>
											{rt?.count}
										</Td>
										<Td position={4} index={index} fontSize='20px'>
											=
										</Td>
										<Td position={5} index={index} fontSize='20px'>
											{rt?.total}
										</Td>
									</Tr>
								))
							) : (
								<Tr>
									<Td position={0} colSpan={6} fontSize='16px' textAlign='center'>
										No data
									</Td>
								</Tr>
							)}
						</Tbody>

						{rtData?.listData?.length > 0 && (
							<Tfoot>
								<TfootTr>
									<TfootTd colSpan={5} textAlign='center' fontSize='20px'>
										Total
									</TfootTd>
									<TfootTd colSpan={1} textAlign='left' fontSize='20px'>
										{rtData?.totalAmount}
									</TfootTd>
								</TfootTr>
							</Tfoot>
						)}
					</Table>
				</Main>
			)}
		</Main>
	);
};
